(() => {
  'use strict';
  if (window.__acCartStyleMounted) return;
  const node = document.getElementById('ac-cart-style-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  if (config.enabled !== true) return;
  window.__acCartStyleMounted = true;
  const preview = config.themeRole !== 'main'
    ? new URL(window.location.href).searchParams.get('ac_cart_style_preview') : null;
  let assigned = preview === 'v1b' || preview === 'control' ? preview : null;
  let scheduled = false;
  let deferred;
  let attempts = 0;
  let polling;

  function readAssignment() {
    if (assigned) return;
    const user = window.igData?.user;
    if (typeof user?.getTestGroup !== 'function') return;
    let group;
    try { group = user.getTestGroup(config.experimentId); } catch (_) { return; }
    const arm = group && config.groupIds?.[group.id];
    if (arm !== 'control' && arm !== 'v1b') return;
    assigned = arm;
    clearInterval(polling);
  }

  function busy(drawer) {
    if (!drawer) return false;
    if (drawer.inert || drawer.matches('[aria-busy="true"]')) return true;
    if (drawer.querySelector('.loading, [aria-disabled="true"], [aria-busy="true"], .cart__items--disabled, .loading-overlay:not(.hidden)')) return true;
    const focused = document.activeElement;
    if (!(focused instanceof Element) || !drawer.contains(focused)) return false;
    if (focused.matches('input, select, textarea')) return true;
    return Boolean(focused.closest('[data-ac-style-mount]')) &&
      focused.matches('button, a, [tabindex]:not([tabindex="-1"])');
  }

  function mount() {
    scheduled = false;
    readAssignment();
    document.querySelectorAll('[data-ac-style-slot]').forEach(slot => {
      const arm = slot.dataset.acEligible === 'true' ? assigned || 'control' : 'control';
      slot.dataset.acStyleAssignment = assigned || 'unassigned';
      if (arm !== 'v1b' || slot.dataset.acStyleMounted === 'v1b') return;
      const drawer = slot.closest('cart-drawer');
      const target = slot.querySelector('[data-ac-style-mount]');
      const source = slot.querySelector('template[data-ac-style-v1b]');
      if (!target || !source?.content) return;
      if (busy(drawer)) {
        clearTimeout(deferred);
        deferred = setTimeout(schedule, 150);
        return;
      }
      target.replaceChildren(source.content.cloneNode(true));
      slot.dataset.acStyleMounted = 'v1b';
      requestAnimationFrame(() => {
        if (!target.isConnected) return;
        target.querySelectorAll('splide-component').forEach(slider => slider.acSlider?.refresh());
      });
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(mount);
  }

  function start() {
    mount();
    const observer = new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(item =>
        item.nodeType === 1 && (item.matches?.('[data-ac-style-slot]') || item.querySelector?.('[data-ac-style-slot]'))))) schedule();
    });
    observer.observe(document.body, {childList:true, subtree:true});
    polling = setInterval(() => {
      schedule();
      if (++attempts >= 40 || assigned) clearInterval(polling);
    },250);
  }

  window.addEventListener('ig:ready',schedule);
  window.addEventListener('pageshow',schedule);
  document.addEventListener('shopify:section:load',schedule);
  document.addEventListener('focusout',event => {
    if (event.target instanceof Element && event.target.closest('cart-drawer')) schedule();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();